var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tasksBox"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"titleIcon",on:{"click":_vm.goBack}},[_c('i',{staticClass:"el-icon-arrow-left"})]),_c('h2',[_vm._v("任务")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }